import type { TFunction } from 'i18next'

// using No title, as this matches the Python API behavior
export const UntitledConfigurationPlaceholder = 'No title'
export const MarketDenominationPlaceholder = 'No Market Denomination'

export function extractTitle(title: string | undefined, marketDenomination: string | undefined, t: TFunction) {
  let configurationTitle = title
  const defaultConfigurationTitle = t('configuration.title.placeholder', { ns: 'shared' })
  if (!configurationTitle || configurationTitle === UntitledConfigurationPlaceholder) {
    configurationTitle = marketDenomination ?? defaultConfigurationTitle
  }
  return { defaultConfigurationTitle, configurationTitle }
}

export const isEmptyOrDefaultMarketDenomination = (currentDenomination: string | undefined, t: TFunction) =>
  !currentDenomination ||
  currentDenomination.length <= 0 ||
  currentDenomination === MarketDenominationPlaceholder ||
  currentDenomination === t('configuration.denomination.placeholder', { ns: 'shared' })
// the inverse can make assertions about the type
const isNotEmptyOrDefaultMarketDenomination = (currentDenomination: string | undefined, t: TFunction): currentDenomination is string =>
  !isEmptyOrDefaultMarketDenomination(currentDenomination, t)

export const getMarketDenomination = (currentDenomination: string | undefined, t: TFunction) => {
  const defaultDenomination = t('configuration.denomination.placeholder', { ns: 'shared' })
  if (isNotEmptyOrDefaultConfigurationTitle(currentDenomination, t)) {
    return currentDenomination
  }
  return defaultDenomination
}

export const isEmptyOrDefaultConfigurationTitle = (currentTitle: string | undefined, t: TFunction) =>
  !currentTitle ||
  currentTitle.length <= 0 ||
  currentTitle === UntitledConfigurationPlaceholder ||
  currentTitle === t('configuration.title.placeholder', { ns: 'shared' })
// the inverse can make assertions about the type
const isNotEmptyOrDefaultConfigurationTitle = (currentTitle: string | undefined, t: TFunction): currentTitle is string =>
  !isEmptyOrDefaultConfigurationTitle(currentTitle, t)

export const getConfigurationTitle = (currentTitle: string | undefined, currentDenomination: string | undefined, t: TFunction) => {
  if (isNotEmptyOrDefaultConfigurationTitle(currentTitle, t)) {
    return currentTitle
  }
  if (isNotEmptyOrDefaultMarketDenomination(currentDenomination, t)) {
    return currentDenomination
  }
  return t('configuration.title.placeholder', { ns: 'shared' })
}
